/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */
/**
 * <p>This enum represents the operation to be performed on a file<\/p>
 **/
export var FileOperationType;
(function (FileOperationType) {
    FileOperationType["DOWNLOAD"] = "DOWNLOAD";
    FileOperationType["UPLOAD"] = "UPLOAD";
})(FileOperationType || (FileOperationType = {}));
